module.exports = __webpack_public_path__ + "static/info1-5f2e31e443d36ff074558ed925e427e7.png";